import { MutationTree } from 'vuex'
import { SchedulingState } from './types'
import * as types from './mutationType'


export const mutations: MutationTree<SchedulingState> = {
  handler: () => {},
  [types.SAMPLE] () {
    console.log('call SAMPLE')
  },
  [types.SET_DASHBOARD] (state: any, res: any) {
    state.dashboardData = [].concat(res)
  },
  [types.SET_ROOMS] (state: any, res: any) {
    state.rooms = [].concat(res)
  },
  [types.SET_COMPANY] (state: any, res: any) {
    state.dayPlanNg = res.dayPlanNg
    state.dayPlanOk = res.dayPlanOk
    state.timePlanNg = res.timePlanNg
    state.timePlanOk = res.timePlanOk
    state.sharingAdjustmentNg = res.sharingAdjustmentNg
    state.sharingAdjustmentOk = res.sharingAdjustmentOk
    state.defaultLang = res.defaultLang
    state.workHourSetting = { ...res.workHourSetting }
  },
  [types.SET_USER] (state: any, res: any) {
    state.availableLocations = res.availableLocations
    state.selectedLocation = res.selectedLocation
    state.userDayPlanNg = res.userDayPlanNg
    state.userDayPlanOk = res.userDayPlanOk
    state.userTimePlanNg = res.userTimePlanNg
    state.userTimePlanOk = res.userTimePlanOk
    state.userSharingAdjustmentNg = res.userSharingAdjustmentNg
    state.userSharingAdjustmentOk = res.userSharingAdjustmentOk
  },
  [types.SET_USER_SETTING] (state: any, res: any) {
    state.userSettingData = [].concat(res)
  },
  [types.INIT_SETUP_STATE] (state: any, isAdmin: boolean) {
    state.setupState.calendar = 'active'
    state.setupState.roomResource = isAdmin ? 'yet' : 'disable'
    state.setupState.schedulingCommon = isAdmin ? 'yet' : 'disable'
    state.setupState.personal = 'yet'
    state.setupState.chat = isAdmin ? 'yet' : 'disable'
  },
  [types.SET_DONE_SETUP_STATE] (state: any, t: any) {
    state.setupState[t.target] = 'done'
    state.setupState[t.next] = 'active'
  },
  [types.SET_SKIP_SETUP_STATE] (state: any, t: any) {
    state.setupState[t.target] = 'skip'
    state.setupState[t.next] = 'active'
  },
  [types.SET_ACTIVE_SETUP_STATE] (state: any, t: any) {
    state.setupState[t.target] = 'active'
    state.setupState[t.prev] = 'yet'
  }
}
